import { render } from "./SectionsDetailTable.vue?vue&type=template&id=37422882&scoped=true"
import script from "./SectionsDetailTable.vue?vue&type=script&lang=js"
export * from "./SectionsDetailTable.vue?vue&type=script&lang=js"

import "./SectionsDetailTable.vue?vue&type=style&index=0&id=37422882&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37422882"]])

export default __exports__